import React from 'react';

const teamMembers = [
  {
    name: 'ApeDev',
    role: 'Founder & Lead Developer',
    avatar: '/apedev.png',
    description: '6+ years blockchain development. TON ecosystem contributor. FunC/Tact specialist.',
    skills: ['Smart Contracts', 'Security', 'TON/FunC'],
  },
  {
    name: 'ApeGamer',
    role: 'Head of Game Design',
    avatar: '/apegamer.png',
    description: '8+ years game development. Casino mechanics expert. Provably fair systems designer.',
    skills: ['Game Math', 'RNG Systems', 'UX Design'],
  },
  {
    name: 'ApeMarketer',
    role: 'Head of Growth',
    avatar: '/apemarketer.png',
    description: '5+ years crypto marketing. Built communities from 0 to 100K+. Meme culture specialist.',
    skills: ['Community', 'Viral Growth', 'Partnerships'],
  },
  {
    name: 'ApeSec',
    role: 'Security Advisor',
    avatar: '/apesec.png',
    description: '10+ years cybersecurity. White-hat hacker. Found critical bugs in major DeFi protocols.',
    skills: ['Auditing', 'Penetration Testing', 'Risk Assessment'],
  },
];

export default function TeamPage() {
  return (
    <div style={{ padding: '16px 16px 100px', minHeight: '100vh', background: '#0a0a0a' }}>
      <h1 style={{
        textAlign: 'center',
        color: '#4ade80',
        fontSize: 24,
        marginBottom: 8,
        fontWeight: 700
      }}>
        Meet the Team
      </h1>
      <p style={{
        textAlign: 'center',
        color: '#888',
        fontSize: 13,
        marginBottom: 24,
        maxWidth: 300,
        margin: '0 auto 24px'
      }}>
        Building the future of gaming on TON. Pseudonymous by choice, transparent by design.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {teamMembers.map((member) => (
          <div
            key={member.name}
            style={{
              background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
              borderRadius: 16,
              padding: 16,
              border: '1px solid #2a2a4a',
            }}
          >
            <div style={{ display: 'flex', gap: 14 }}>
              <img
                src={member.avatar}
                alt={member.name}
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: 12,
                  objectFit: 'cover',
                  border: '2px solid #4ade80',
                }}
              />
              <div style={{ flex: 1 }}>
                <h3 style={{
                  color: '#fff',
                  fontSize: 18,
                  margin: 0,
                  fontWeight: 600
                }}>
                  {member.name}
                </h3>
                <p style={{
                  color: '#4ade80',
                  fontSize: 13,
                  margin: '2px 0 8px',
                  fontWeight: 500
                }}>
                  {member.role}
                </p>
                <p style={{
                  color: '#aaa',
                  fontSize: 12,
                  margin: 0,
                  lineHeight: 1.4
                }}>
                  {member.description}
                </p>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: 8,
              marginTop: 12,
              flexWrap: 'wrap'
            }}>
              {member.skills.map((skill) => (
                <span
                  key={skill}
                  style={{
                    background: 'rgba(74, 222, 128, 0.15)',
                    color: '#4ade80',
                    padding: '4px 10px',
                    borderRadius: 20,
                    fontSize: 11,
                    fontWeight: 500,
                  }}
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: 24,
        padding: 16,
        background: 'rgba(74, 222, 128, 0.1)',
        borderRadius: 12,
        border: '1px solid rgba(74, 222, 128, 0.2)',
      }}>
        <p style={{
          color: '#4ade80',
          fontSize: 13,
          margin: 0,
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          "We let the code and product speak for us. Everything is verifiable on-chain."
        </p>
      </div>
    </div>
  );
}
